document.addEventListener("DOMContentLoaded", e => {
  const targetNode = document.querySelector('#AjaxCartSubtotal');
  
  if (targetNode) {
    const observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'childList' || 
          mutation.type === 'subtree'
        ) {
          if (typeof BSS_B2B !== 'undefined' && BSS_B2B.observer && BSS_B2B.observer.cartSubject) {
            BSS_B2B.observer.cartSubject.listenCartCheckout();
          }
        }
      }
    });
  
    const config = { childList: true, subtree: true };
  
    observer.observe(targetNode, config);
  }
  const isCartPage = window.location.href.includes('/cart');
  if (isCartPage) {
    const checkOutElement = document.querySelector('#CheckOut');
    const buttonWrapper = document.querySelector('#bss-b2b-net-term-button-wrapper');
    const agreeCheckbox = document.querySelector('#AgreeToTos');
    
    if (checkOutElement && buttonWrapper) {
    checkOutElement.insertAdjacentElement('afterend', buttonWrapper);
    }

    if (agreeCheckbox && checkOutElement) {
      const toggleButtonState = () => {
      if (agreeCheckbox.checked) {
        checkOutElement.style.opacity = '1';
        checkOutElement.style.pointerEvents = 'auto';
      } else {
        checkOutElement.style.opacity = '0.36';
        checkOutElement.style.pointerEvents = 'none';
      }
      };
      
      toggleButtonState();
      
      agreeCheckbox.addEventListener('change', toggleButtonState);
    }
      
  }
})

const ADDRESS_INPUT_MAP = new Map([
    ["first_name", "first-name"],
    ["last_name", "last-name"],
    ["address1", "address-field"],
    ["address2", "apartment-field"],
    ["city", "city-field"],
    ["zip", "zip-field"],
    ["country_code", "country-field"],
    ["country_name", "country-name"],
    ["company", "company-field"]
]);

function watchB2BAddressSelect() {
    const findSelect = setInterval(() => {
        const select = document.querySelector('#b2b-nt-address-select');
        if (!select) return;
      
        const options = Array.from(select.querySelectorAll('option'));
        const hasNew = options.some(opt => opt.value === 'new');
        const otherOptions = options.filter(opt => opt.value !== 'new');
      
        if (hasNew && otherOptions.length > 0) {
          const { customer } = window.BSS_B2B?.shopData;
          const options = [];
      
          customer?.addresses?.forEach((item) => {
              const address = [item.address1, item.country].filter(Boolean).join(" ");
              const name = [item.first_name, item.last_name].filter(Boolean).join(" ");
              options.push({ id: item.id, label: `${address} (${name})` });
          });
          select.value = otherOptions[0].value;
          const address = customer.addresses.find((item) => item.id === Number(otherOptions[0].value));
          if (address) {
              [...ADDRESS_INPUT_MAP.keys()].forEach((key) => {
                  const inputId = ADDRESS_INPUT_MAP.get(key);
                  const input = document.querySelector(`#b2b-nt-address-info #${inputId}`) || document.querySelector(`.b2b-nt-addition-info #${inputId}`);
                  if (input) {
                      input.value = address[key] || "";
                      const event = new Event("change", { bubbles: true });
                      input.dispatchEvent(event);
                  }
              });
          }
          const newOption = select.querySelector('option[value="new"]');
          if (newOption) {
            newOption.remove();
          }
        }
        clearInterval(findSelect);
    }, 100);

    setTimeout(()=> {
      clearInterval(findSelect);
    },3000)
  
}

const findButtonInterval = setInterval(() => {
    const ntBtn = document.querySelector('#bss-b2b-net-term-button');
  if (ntBtn) {
    ntBtn.addEventListener('click', () => {
          watchB2BAddressSelect();
    });
    clearInterval(findButtonInterval);
  }
}, 200);

setTimeout(()=> {
  clearInterval(findButtonInterval);
},3000)